import FeedPage from './FeedPage';
import { runSearch } from '../redux/search/actions';
import { connect } from 'react-redux';
import { getRestOfContext } from '../redux/rootActions';

const _mapStateToProps = ({ app, user }) => ({
    isMobile: app.isMobile,
    isAuthenticated: user.isAuthenticated,
    userId: user.publicId,
});

const _mapDispatchToProps = {
    handleSearch: runSearch,
    handleRestOfContext: getRestOfContext,
};

export default connect(_mapStateToProps, _mapDispatchToProps)(FeedPage);
